'use strict';

var Base64 = require('spotify-crypto/base64');

var randomString = {};

/**
 * Generate a random Byte string of a specified length.
 *
 * @param {number} numberOfBytes The requested length of the string.
 * @return {string} The generated string.
 */
randomString.generate = function(numberOfBytes) {
  var generated = '';
  for (var i = 0; i < numberOfBytes; i++) {
    generated += String.fromCharCode(Math.random() * 256 | 0);
  }
  return generated;
};

/**
 * Generate a random Base64 encoded string of a specified byte length.
 *
 * @param {number} numberOfBytes   The length of the string in bytes (before
 *     encoding).
 * @return {string} The generated Base64 encoded string.
 */
randomString.generateBase64 = function(numberOfBytes) {
  return Base64.encode(randomString.generate(numberOfBytes));
};

module.exports = randomString;
